<template>
	<div class="form-sub-section notes-section">
        <div class="d-flex justify-content-between">
            <span class="margin-right-auto">
            <h3 class="main-text-large">{{$t("res_Label_Notes")}}</h3>
            </span>
            <v-btn class="dgs-new-button ml-2 mr-1" @click="openAddNoteDialog(1, 0)" v-if="viewMode != 'readonly'">{{$t("res_ButtonText_Add")}}</v-btn>
            <v-btn @click="collapseNotes = !collapseNotes"
                   class="dgs-new-button" style="width: 40px; min-width: unset !important">
                <span v-if="collapseNotes" class="arrow-down"></span>
                <span v-else class="arrow-up"></span>
            </v-btn>  
        </div>
        <v-divider v-if="!collapseNotes && notesFullList.length > 0"></v-divider>
		<div v-bind:class="{ 'with-view-all' : notesFullList.length > defaultNumberOfNotesToDisplay }" :style="{ display: collapseNotes ? 'none':'block' }">
            <v-list>
				<v-list-item 
                class="text-hover-list" v-for="(item, i) in notes" :key="i" @dblclick="openPreviewFullNote(item)">
                    <!-- <v-icon large class="attachment_icon p-0">mdi-note</v-icon>-->
                    <v-list-item-content >
                        <v-list-item-title>
                            <div class="main-text-large text-limit text-wrap w-75">
                                <span>{{ item.title }}</span>
                            </div>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            <span v-if="item.createdBy && item.createdBy.length > 35" class="action-label-new overflow-hidden text-nowrap overflow-ellipsis" v-tooltip="item.createdBy">
                                {{$t("res_Label_CreatedBy")+ " : " + item.createdbyname }} ...
                            </span>
                            <span v-else class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                {{$t("res_Label_CreatedBy")+ " : " + item.createdbyname }}
                            </span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                            <span v-if="item.createdDate && item.createdDate.length > 32"  class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                {{ $t("res_MenuItems_TaskProjectCreatedDate") + " : " + utils.formatDateTime(item.createdDate) }}
                            </span>
                            <span v-else class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                {{ $t("res_MenuItems_TaskProjectCreatedDate") + " : " + utils.formatDateTime(item.createdDate) }}
                            </span>
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action-text v-if="viewMode != 'readonly' && item.isEditable">
                        <v-menu bottom offset-y  content-class="" attach :left="!$vuetify.rtl" :right="$vuetify.rtl">
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item v-bind="attrs" v-on="on" class="justify-content-between">
                                    <div class="custom-icon-wrapper">
                                        <v-icon>custom-icon white-bg vertical-dots-icon</v-icon>
                                    </div>
                                </v-list-item>
                            </template>
                            <v-list class="list-actions">
                                <v-list-item @click="openAddNoteDialog(2, item.id)">
                                    <v-list-item-content>
                                        <v-list-item-title>{{$t("res_ButtonText_Edit")}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click="openDeleteNoteDialog(item.id)">
                                    <v-list-item-content>
                                        <v-list-item-title>{{$t("res_ButtonText_Delete")}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-list-item-action-text>
                </v-list-item>
            </v-list>

            <v-divider class="view-all-divider" v-if="notesFullList.length > defaultNumberOfNotesToDisplay"></v-divider>
            <div class="view-all-wrapper d-flex justify-content-center align-content-center" v-if="notesFullList.length > defaultNumberOfNotesToDisplay">
                <button class="view-all-btn d-flex align-items-center" @click="viewAllNotes()" v-if="numberOfNotesToDisplay != 1000">
                    {{ $t("res_ButtonText_ViewAll") }} <v-icon class="light">mdi-chevron-down</v-icon>
                </button>
                <button class="view-all-btn d-flex align-items-center" @click="viewAllNotes()" v-if="numberOfNotesToDisplay == 1000">
                    {{ $t("res_ButtonText_ShowLess") }} <v-icon class="light">mdi-chevron-up</v-icon>
                </button>
            </div>

            <!-- <label class="empty-list" v-if="notes.length === 0">
                {{ $t("res_Label_NoNotes") }}
            </label> -->

            <v-dialog v-model="deleteNoteDialog" content-class="small-dialog" width="350" height="250">
                <v-card>
                    <v-card-title>
                        {{$t("res_Label_DeleteNotes")}}
                    </v-card-title>
					<div class="card-body">
                        <label>{{$t("res_Msgs_DeleteNoteConfirm")}}</label>
                    </div>
					<v-card-actions class="sticky-actions">
                        <v-spacer></v-spacer>
						<v-btn color="light-blue" @click="deleteNoteDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
						<v-btn color="primary" @click="deleteNote">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="addNoteDialog" content-class="small-dialog add-note-dialog" width="500" height="350">
                <v-card>
                    <v-card-title>
                        {{ heading }}
                    </v-card-title>
					<div class="card-body">
                        <label>{{ $t("res_Msgs_EnterNotes") }} *</label> 
                        <mc-wysiwyg v-if="enableRichTextForNotes == true" v-model="noteText"></mc-wysiwyg>
                        <v-textarea v-else v-model="noteText" solo></v-textarea>  
                        <div id="warning" style="color: red; display: none;" >{{$t("res_Msgs_Min10Characters")}}</div>
                    </div>
					<v-card-actions class="sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="light-blue" @click="resetForm">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn color="primary" @click="addNote" v-if="form_mode === 'add'">{{$t("res_ButtonText_Continue")}}</v-btn>
                        <v-btn color="primary" @click="updateNote" v-if="form_mode === 'edit'">{{$t("res_ButtonText_Continue")}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="previewFullNoteDialog" content-class="small-dialog" width="500" height="350">
                <v-card>
                    <v-card-title>
                        {{$t("res_Label_NoteDetails")}}
                    </v-card-title>
                    <v-card-text>
                        <p>{{ previewedNote.text }}</p>
                        <v-divider></v-divider>
                        <div class="d-flex justify-content-between">
                            <span>{{$t("res_Label_CreatedBy")+ " : " + previewedNote.createdBy }}</span>
                            <span>{{ $t("res_MenuItems_TaskProjectCreatedDate") + " : " + utils.formatDateTime(previewedNote.createdDate) }}</span>
                        </div>
                    </v-card-text>
                    <v-card-actions class="sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="light-blue" @click="previewFullNoteDialog = false">{{ $t("res_ButtonText_Close") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants'
    import * as utils from '@/assets/js/common.js'

	export default {
        name: 'Notes',
        props: {
            documentId: { type: [String, Number], default: '0' },
            transferId: { type: [String, Number], default: '0' },
            viewMode: { type: String, default: 'readonly' },
        },
        data() 
        {
            return {
                utils: utils,
                enableRichTextForNotes: window.enableRichTextForNotes,
                notesLength: 20,
                notes: [],
                notesFullList: [],
                noteId: 0,
                noteText: "",
                noteTextCopy: "",
                heading: "",
                deleteNoteDialog: false,
                addNoteDialog: false,
                form_mode: 'add',
                currentNoteId: 0,
                defaultNumberOfNotesToDisplay: 3,
                numberOfNotesToDisplay: 3,
                collapseNotes: false,
                previewFullNoteDialog: false,
                previewedNote: {
                    text: '',
                    createdBy: '',
                    createdDate: ''
                },
            };
        },
        mounted() 
        {
            this.getNotes()
        },
        watch: 
        {
            documentId()
            {
                this.getNotes()
                this.resetForm()
            }
        },
        methods: 
        {
            openPreviewFullNote(note)
            {
                this.previewedNote = {
                    text: note.title,
                    createdBy: note.createdbyname,
                    createdDate: note.createdDate
                }
                this.previewFullNoteDialog = true
            },
            getNotes()
            {
                if (this.documentId == 0)
                    return
                
                this.notes = []
                this.notesFullList = []
                this.numberOfNotesToDisplay = this.defaultNumberOfNotesToDisplay

                axios.get(constants.baseApiUrl + 'Note/GetNotes?documentId=' + this.documentId)
                    .then(response => 
                    {
                        this.notes = []
                        response.data.forEach(element => 
                        {
                            var noteElement = { id: element.id, title: this.decodeHtmlEntities(element.noteText), isEditable: element.isEditable,createdbyname: element.createdByUser,createdDate :element.createdDate}
                            if (this.notes.length < this.defaultNumberOfNotesToDisplay)
                                this.notes.push(noteElement)
                            this.notesFullList.push(noteElement)
                        });
                    })
                    .catch(error => this.handleError(error))
            },
            decodeHtmlEntities(htmlString) {
                var doc = new DOMParser().parseFromString(htmlString, 'text/html');
                return doc.body.textContent || "";
            },
            openDeleteNoteDialog(noteId)
            {
                this.currentNoteId = noteId
                this.deleteNoteDialog = true
            },
            deleteNote()
            {
                this.deleteNoteDialog = false
                axios.get(constants.baseApiUrl + 'Note/DeleteNote?id=' + this.currentNoteId + '&documentId=' + this.documentId)
                    .then(res =>{
                         this.getNotes()
                         window.showAlert('res_Msgs_NotesDeleted', 'success')
                    })
                    .catch(error => this.handleError(error))
            },
            openAddNoteDialog(option, noteId)
            { 
                this.noteId = noteId;

                if (option === 1)
                {
                    this.heading = window.translate("res_Label_NewNote")
                    this.addNoteDialog = true
                }
                else if(option === 2)
                {
                    this.heading = window.translate("res_Label_EditNote")
                    this.form_mode = 'edit'
                    this.getSelectedNote()
                }
            },
            addNote()
            {
                if (this.noteText.trim().length == 0)
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return
                }

                var upsertNoteRequest = { DocumentId: this.documentId, TransferId: this.transferId, NoteText: this.noteText.trim() }

                axios.post(constants.baseApiUrl + 'Note/AddNote', upsertNoteRequest, {headers: constants.headers})
                    .then(res => 
                    { 
                        if (res.data != null)
                        {
                            this.getNotes()
                            this.resetForm()
                            window.showAlert('res_Msgs_NotesAdded', 'success')
                        }
                    })
                    .catch(error => this.handleError(error))
            },
            updateNote()
            {
                if (this.noteText.trim().length == 0)
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return
                }

                var upsertNoteRequest = { NoteId: this.noteId, DocumentId: this.documentId, NoteText: this.noteText.trim()}

                axios.post(constants.baseApiUrl + 'Note/UpdateNote', upsertNoteRequest, {headers: constants.headers})
                    .then(res => 
                    {
                        this.getNotes()
                        this.resetForm()
                        window.showAlert('res_Msgs_NotesUpdated', 'success')
                    })
                    .catch(error => this.handleError(error))
            },
            resetForm()
            {
                this.addNoteDialog = false
                this.noteText = ''
                this.form_mode = 'add'
            },
            getSelectedNote()
            {
                axios.get(constants.baseApiUrl + 'Note/GetSpecificNote?documentId=' + this.documentId + '&noteId=' + this.noteId, {headers: constants.headers})
                    .then(response => 
                    { 
                        this.noteText = response.data.noteText
                        this.addNoteDialog = true;
                        this.createdbyname = response.data.createdbyname
                    })
                    .catch(error => this.handleError(error))
            },
            handleError(error)
            {
                console.log(error)
                window.showAlert("res_Msgs_ErrorOccured", 'error')
            },
            viewAllNotes()
            {
                if (this.numberOfNotesToDisplay == 1000)
                {
                    this.numberOfNotesToDisplay = this.defaultNumberOfNotesToDisplay
                    this.notes = this.notesFullList.slice(0, this.defaultNumberOfNotesToDisplay)
                }
                else
                {
                    this.numberOfNotesToDisplay = 1000
                    this.notes = this.notesFullList
                }
            }
        }
    }

    import 'floating-vue/dist/style.css'
</script>

<style scoped>
    .attachment_icon { font-size: 30px; padding-left: 5px; padding-right: 5px; color: cornflowerblue; }
    .white-container { padding-bottom: 0px; }
</style>